module.exports = __webpack_public_path__ + "static/media/user-ico-dark.4d9ac414.svg";